module.exports = __webpack_public_path__ + "static/media/halluxguard-3.ed27fecb.jpg";